import React from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import Logo from '../../assets/img/logo.png'
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
// core components

function NavigationBar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [bodyClick, setBodyClick] = React.useState(false);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
   
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 499 ||
        document.body.scrollTop > 499
        ) {
          setNavbarColor("navbar-white");
      } else if (
        document.documentElement.scrollTop < 500 ||
        document.body.scrollTop < 500
        ) {
          setNavbarColor("navbar-transparent");
          
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {bodyClick && collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(false);
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar
        className={classnames("fixed-top pt-0", navbarColor)}
        expand="lg"
        id="navbar-main"
      >
        <Container>
          <div className="navbar-translate">
            <NavbarBrand id="navbar-brand" className="py-0" href="#headers">
              <img src={Logo} style={{width:'80px'}} alt="img-logo"/>
            </NavbarBrand>
            <button
              className="navbar-toggler"
              id="navigation"
              type="button"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setBodyClick(true);
                setCollapseOpen(true);
              }}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle className="mr-2" color="default" caret nav>
                  Proyecto
                </DropdownToggle>
                <DropdownMenu className="dropdown-danger" right>
                  {/* <DropdownItem to="/#nosotros" tag={Link}>
                    Nosotros
                  </DropdownItem> */}
                  <DropdownItem 
                    to="/#proyecto" 
                    tag={Link}
                    onClick={() => {
                      setBodyClick(false);
                      setCollapseOpen(false);
                      document.documentElement.classList.remove("nav-open");
                    }}
                  >
                    El Proyecto
                  </DropdownItem>
                  <DropdownItem 
                    to="/#caracteristicas" 
                    tag={Link}
                    onClick={() => {
                      setBodyClick(false);
                      setCollapseOpen(false);
                      document.documentElement.classList.remove("nav-open");
                    }}
                  >
                    Características
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink 
                  to="/#masterplan" 
                  tag={Link}
                  onClick={() => {
                    setBodyClick(false);
                    setCollapseOpen(false);
                    document.documentElement.classList.remove("nav-open");
                  }}
                >
                  Masterplan 360
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  to="/#atractivos" 
                  tag={Link}
                  onClick={() => {
                    setBodyClick(false);
                    setCollapseOpen(false);
                    document.documentElement.classList.remove("nav-open");
                  }}
                >
                  Atractivos Turísticos
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  to="/#ubicacion" 
                  tag={Link}
                  onClick={() => {
                    setBodyClick(false);
                    setCollapseOpen(false);
                    document.documentElement.classList.remove("nav-open");
                  }}
                >
                  Ubicación
                </NavLink>
              </NavItem>
              <NavItem>
                <Button
                  className="btn-round"
                  color="danger"
                  to="/#contacto"
                  tag={Link}
                  onClick={() => {
                    setBodyClick(false);
                    setCollapseOpen(false);
                    document.documentElement.classList.remove("nav-open");
                  }}
                >
                 Contacto
                </Button>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}
export default NavigationBar;
